import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useStore, StoreTypes } from 'context';
import { gaPageView } from 'util/ga';

const PAGE_TITLE_MAP = {
  // '/ClassView': '課程',
  '/NaniMainPage': 'NaniStudy 首頁',
  '/PurchaseListView': '我的課程',
  '/MyOrders': '購買紀錄',
  '/MyOrderDetails': '訂單明細',
  '/ProductView': '商品',
  '/PurchaseFillInfos': '結帳填寫',
  '/PurchaseRouter': '金流載入',
  '/PurchaseSuccess': '購買成功',
  '/PurchaseFailed': '購買失敗',
  '/ServiceView': '服務條款',
  '/ReportView': '測驗中繼',
};

export const useGAPageView = () => {
  const location = useLocation();
  const [{ productName }] = useStore(StoreTypes.global);

  // 一般頁面：路由切換時立刻送
  useEffect(() => {
    if (location.pathname === '/ClassView') return;
    gaPageView({
      page_location: location.pathname,
      page_title: PAGE_TITLE_MAP[location.pathname] || location.pathname,
    });
  }, [location.pathname]);

  // ClassView：等課程名稱從 LeftPannel2 dispatch 進 global store 後才送
  useEffect(() => {
    if (location.pathname !== '/ClassView' || !productName) return;
    gaPageView({
      page_location: '/ClassView',
      page_title: productName,
    });
  }, [location.pathname, productName]);
};
